import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';
import { Patient as WaitlistPatient } from '@dreryk/egabinet-waitlist-frontend-api';

import { TranslateFunction } from '@dreryk/react-common';

import { getPatientReferenceIdentifierTranslatableText } from '~libs.shared.patient';

import { translationKeys } from '../../../translations';

import { isPatientSimple } from './PatientField.utils';

export const getPatientDetails = (patient: PatientSimple | WaitlistPatient, translate: TranslateFunction): string => {
   let result = '';
   if (isPatientSimple(patient) && patient.referenceIdentifier) {
      result += translate(getPatientReferenceIdentifierTranslatableText(patient.referenceIdentifier));
   }

   if (result && patient.phoneNumber) {
      result += ', ';
   }

   if (patient.phoneNumber) {
      result += `${translate(translationKeys.phoneAbbreviation)} ${patient.phoneNumber.asString()}`;
   }
   return result;
};
